export enum Channel {
  Intermediary = 'intermediary',
  Customer = 'customer',
}
